import * as React from 'react';
import { Link } from 'react-router-dom';
import { ShippingMethod } from '../shipping-method';
import { countries, Country } from 'typed-countries';

export interface ProductListItemProps {
  method: ShippingMethod;
  index: number;
}

const WORLDWIDE = 'Worldwide';

const indicatorClasses = (active: boolean) => {
  return `db w1 h1 br-100 bg-${active ? 'green' : 'red'}`;
};

const visibility = (method: ShippingMethod) => {
  if (method.available_worldwide) {
    return WORLDWIDE;
  }

  return method.available_in
    .map((item: string) => {
      const country = countries.find(
        (country: Country) => country.iso === item,
      );
      if (country) {
        return country.name;
      }

      return item;
    })
    .join(', ');
};

const getPrice = (value: number, currency: string) => (
  <React.Fragment>
    {currency} {(value / 100).toFixed(2)}
  </React.Fragment>
);

export default function ShippingMethodListItem(props: ProductListItemProps) {
  return (
    <div
      className={`flex justify-stretch items-center pv2 pv3-ns ${
        props.index > 0 ? 'bt b--black-10' : ''
      }`}
    >
      <div className="mr4">
        <div className={indicatorClasses(props.method.available)} />
      </div>
      <div className="w-20">
        <h4 className="lh-copy ma0 mb2 f7 black-50 ttu">
          {props.method.zone || 'No Zone'}
        </h4>
        {props.method.name}
      </div>
      <div className="flex-auto w-40">
        <h4 className="lh-copy ma0 mb2 f7 black-50 ttu">Territories</h4>
        {visibility(props.method)}
      </div>
      <div className="pl3 pl4-ns w-20">
        <h4 className="lh-copy ma0 mb2 f7 black-50 ttu">Availability</h4>
        {props.method.delivery_time_days} Days
      </div>
      <div className="pl3 pl4-ns w-20">
        <h4 className="lh-copy ma0 mb2 f7 black-50 ttu">Price</h4>
        {props.method.is_free
          ? 'FREE'
          : getPrice(props.method.price_amount, props.method.price_currency)}
      </div>
      <div className="pl3 pl4-ns w-20">
        <h4 className="lh-copy ma0 mb2 f7 black-50 ttu">Subtotal </h4>
        {props.method.min_subtotal > 0 ? (
          <React.Fragment>
            Min{' '}
            {getPrice(props.method.min_subtotal, props.method.price_currency)}
          </React.Fragment>
        ) : (
          '–'
        )}
        {props.method.max_subtotal > 0 ? (
          <React.Fragment>
            Max{' '}
            {getPrice(props.method.max_subtotal, props.method.price_currency)}
          </React.Fragment>
        ) : (
          '–'
        )}
      </div>
      <div className="pl3 pl4-ns w-20">
        <h4 className="lh-copy ma0 mb2 f7 black-50 ttu">Weight </h4>
        {props.method.min_weight > 0 ? (
          <React.Fragment>Min: {props.method.min_weight}g</React.Fragment>
        ) : (
          '–'
        )}
        {props.method.max_weight > 0 ? (
          <React.Fragment>Max: {props.method.max_weight}g</React.Fragment>
        ) : (
          '–'
        )}
      </div>
      <div className="tc ml4">
        <Link
          to={{
            pathname: `/shipping-methods/${props.method.id}`,
            state: {
              method: props.method,
            },
          }}
          className="link black underline b dim"
        >
          Edit
        </Link>
      </div>
    </div>
  );
}
